// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {ReactComponent as Icon} from './../assets/img/icons/support.svg'
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {handleSetQuery} from "../assets/js/main";


export default function Support() {
  const location = useLocation();


  return (
     <>
       <div className="supportComponent">
         <Link to={{pathname: '/support', search: location?.search}} id="support">
           <Icon/>
         </Link>
       </div>
     </>
  )
}
